export default "__VITE_ASSET__DwshAGRz__"